exports.env_handshake = process.env.HANDSHAKE_ENV;

exports.external_address = process.env.EXTERNAL_ADDRESS;

exports.google_maps_browser_key = process.env.GOOGLE_MAPS_BROWSER_KEY;

exports.segment_io_api_key = process.env.SEGMENT_IO_API_KEY;

exports.forter_key = process.env.FORTER_SNIPPET_KEY;

exports.cluster_id = process.env.cluster_id;

exports.search_size = 30;

exports.migration_on = 'true' === process.env.MIGRATION_ON;

exports.hideReferral = false;

exports.vat_launched_countries_hash = process.env.VAT_LAUNCHED_COUNTRIES_HASH;

exports.statsig_sdk_key = process.env.STATSIG_SDK_KEY;

exports.intercom_app_id = process.env.INTERCOM_APP_ID;
